import { useState } from "react";
import { Icon } from "@/components/ui/Icon";
import {
  isoDate,
  lastDays,
  previousRange,
  rangeDays,
  type DateRange,
} from "@/lib/api/dashboard";
import "./dashboard.css";

/**
 * Davr tanlagich.
 *
 * Tayyor oraliqlar + ixtiyoriy sanadan sanagacha. Tayyor tugmalar
 * qoldirildi: kundalik ishda eng ko'p kerak bo'lgani «bugun» va
 * «hafta», ularni har safar sana kiritib terish ortiqcha ish
 * bo'lardi.
 *
 * Solishtirish ALOHIDA yoqiladi va sanalari ham qo'lda
 * tanlanadi: «o'tgan hafta bilan» sukut bo'yicha to'g'ri bo'lsa
 * ham, mavsumiy savdoda o'tgan YILNING shu haftasi bilan
 * solishtirish kerak bo'ladi.
 */

const PRESETS = [
  { days: 1, label: "Bugun" },
  { days: 7, label: "7 kun" },
  { days: 30, label: "30 kun" },
];

export function PeriodPicker({
  range,
  onRange,
  compare,
  onCompare,
}: {
  range: DateRange;
  onRange: (value: DateRange) => void;
  compare: DateRange | null;
  onCompare: (value: DateRange | null) => void;
}) {
  const [open, setOpen] = useState(false);
  const today = isoDate(new Date());
  const activePreset = PRESETS.find(
    (preset) =>
      range.to === today && rangeDays(range) === preset.days,
  );

  return (
    <div className="period">
      <div className="segmented" role="group" aria-label="Davr">
        {PRESETS.map((preset) => (
          <button
            key={preset.days}
            type="button"
            className={`segmented-item${activePreset?.days === preset.days ? " active" : ""}`}
            onClick={() => {
              onRange(lastDays(preset.days));
              setOpen(false);
            }}
          >
            {preset.label}
          </button>
        ))}
        <button
          type="button"
          className={`segmented-item${!activePreset || open ? " active" : ""}`}
          onClick={() => setOpen((value) => !value)}
        >
          <Icon name="count" size={13} />
          Sana
        </button>
      </div>

      {(open || !activePreset) && (
        <div className="period-range glass">
          <label className="period-field">
            <span>Dan</span>
            <input
              className="input"
              type="date"
              max={range.to}
              value={range.from}
              onChange={(event) =>
                event.target.value && onRange({ ...range, from: event.target.value })
              }
            />
          </label>
          <label className="period-field">
            <span>Gacha</span>
            <input
              className="input"
              type="date"
              min={range.from}
              max={today}
              value={range.to}
              onChange={(event) =>
                event.target.value && onRange({ ...range, to: event.target.value })
              }
            />
          </label>

          <label className="period-compare">
            <input
              type="checkbox"
              checked={compare !== null}
              onChange={(event) =>
                onCompare(event.target.checked ? previousRange(range) : null)
              }
            />
            <span>Solishtirish</span>
          </label>

          {compare && (
            <>
              <label className="period-field">
                <span>Dan</span>
                <input
                  className="input"
                  type="date"
                  max={compare.to}
                  value={compare.from}
                  onChange={(event) =>
                    event.target.value && onCompare({ ...compare, from: event.target.value })
                  }
                />
              </label>
              <label className="period-field">
                <span>Gacha</span>
                <input
                  className="input"
                  type="date"
                  min={compare.from}
                  max={today}
                  value={compare.to}
                  onChange={(event) =>
                    event.target.value && onCompare({ ...compare, to: event.target.value })
                  }
                />
              </label>
              <button
                type="button"
                className="btn btn-text btn-sm"
                onClick={() => onCompare(previousRange(range))}
              >
                Oldingi davr
              </button>
            </>
          )}
        </div>
      )}
    </div>
  );
}
